<template>
    <section>
        <div v-if="leagueInfo['status']=='pre'">
          <span><h5>You are the Commissioner!</h5></span>
          <form id="start-draft-form" v-on:submit.prevent="startDraft">
            <p id="leagueStatusString">Current Status of your league is: Pre-Season </p>
            <p>When all the teams have joined and you are ready for teams to save their rosters for the draft, click the Start Draft button below</p>
              <button id="submitDraftLeague" type="submit" class="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect">
                Start Draft
              </button>
          </form>
        </div>

        <div v-else-if="leagueInfo['status']=='draft'">
          <form id="start-league-form" v-on:submit.prevent="startLeague">
            <p id="leagueStatusString">Current Status of your league is: Draft </p>
            <p>Once your draft is complete and everyone has saved their teams, click the Start League button below</p>
              <button id="submitStartLeague" type="submit" class="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect">
                Start League
              </button>
          </form>
        </div>
    </section>
</template>

<script>
import { db } from '../db'
import firebase from "firebase";

export default {
  data() {
    return { 
      leagueInfo: null,
    }
  },
  props: {
    leagueKey: { 
      type: String, // not 'string'
      required: true,
      default: "noinit"
     },
     user: {
      type: Object,
      required: true,
      default: null
     }
  },
  components: {
  },
  methods: {
    startDraft: function() {
      db.ref('/leagues/'+this.leagueKey+'/status').set("draft")
    },
    startLeague: function() {
      db.ref('/leagues/'+this.leagueKey+'/status').set("locked")
    }
  },
  watch: {
    leagueKey: {
      // call it upon creation too
      immediate: true,
      handler(leagueKey) {
        this.$rtdbBind('leagueInfo', db.ref('leagues').child(leagueKey))
      },
    },
  },
}

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/CommisionerOptions.vue